const CONST = {
    SYMBOLS: {
        WILD: "2",
        COIN: "0",
        SCATTER: "1",
        COLLECTOR: "11",
        DOUBLER: "12"
    },
    COLUMNS: 5,
    ROWS: 3,
    MAX_WIN_CAP: 5000
}

export {CONST}